// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQItem_faq__MHH0Z","faqTitle":"FAQItem_faqTitle__9bCIM","faqText":"FAQItem_faqText__zINR_","expandIcon":"FAQItem_expandIcon__k8buy","expanded":"FAQItem_expanded__nFhQ3"};